export var ConfigActionType;
(function (ConfigActionType) {
    ConfigActionType["SET_APP_CONFIG"] = "SET_APP_CONFIG";
})(ConfigActionType || (ConfigActionType = {}));
